import { openAPIClient } from '../openApiClient';
import type {
  CopyGlossaryResponse,
  CopyGlossaryServiceConfig,
  CopySpacesResponse,
  CopySpacesServiceConfig,
  DuplicateContentResponse,
  DuplicateContentServiceConfig,
} from './types/index';

export async function duplicateContentService({
  httpRequestConfig,
  params,
}: DuplicateContentServiceConfig): Promise<DuplicateContentResponse> {
  const client = await openAPIClient(httpRequestConfig);

  if (params === undefined) {
    throw new Error('Params are required');
  }

  const response = await client.POST('/v1/auth/admin/duplicateContent', {
    body: params.body,
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }

  return response.data;
}

export async function copySpacesService({
  httpRequestConfig,
  params,
}: CopySpacesServiceConfig): Promise<CopySpacesResponse> {
  const client = await openAPIClient(httpRequestConfig);

  if (params === undefined) {
    throw new Error('Params are required');
  }

  const response = await client.POST('/v1/auth/admin/copySpaces', {
    body: params.body,
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }

  return response.data;
}

export async function copyGlossaryService({
  httpRequestConfig,
  params,
}: CopyGlossaryServiceConfig): Promise<CopyGlossaryResponse> {
  const client = await openAPIClient(httpRequestConfig);

  if (params === undefined) {
    throw new Error('Params are required');
  }

  const response = await client.POST('/v1/auth/admin/copyGlossary', {
    body: params.body,
  });

  if (response.error !== undefined) {
    throw new Error(response.error.message);
  }

  return response.data;
}
